import { ColDef, ColGroupDef } from "ag-grid-community";

export const useYardStatusColumns = () => {
  const columns: (ColDef | ColGroupDef)[] = [
    {
      field: "LocationName",
      headerName: "Location",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "Position",
      headerName: "Position",
      filter: "agNumberColumnFilter",
      type: "numericColumn",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "GroupName",
      headerName: "Group",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "BilletsCount",
      headerName: "Billets Count",
      filter: "agNumberColumnFilter",
      type: "numericColumn",
      flex: 1,
      minWidth: 130,
    },
    {
      field: "Destination",
      headerName: "Destination",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "HeatNumber",
      headerName: "Heat Name",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 130,
    },
    {
      field: "Length",
      headerName: "Length",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "Section",
      headerName: "Section",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "Grade",
      headerName: "Grade",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 120,
    },
  ];

  return { columns };
};
